/**
 * Catálogo explícito de hostnames de portal de cliente. Ninguna otra parte
 * del frontend infiere un slug a partir del hostname — este es el único
 * punto de detección.
 *
 * @remarks
 * `VITE_FORCE_CLIENT_PORTAL_SLUG` es una salida solo para desarrollo local
 * (evita editar `/etc/hosts`); nunca se lee en producción real porque el
 * hostname servido ahí ya es uno de los de `CLIENT_PORTAL_HOSTS`.
 */
export const CLIENT_PORTAL_HOSTS: Readonly<Record<string, string>> = Object.freeze({
  'bahia.sintax.city': 'bahia-blanca',
  'bahia.sintax.local': 'bahia-blanca',
});

export function getClientPortalSlug(hostname: string): string | null {
  const forced = import.meta.env.VITE_FORCE_CLIENT_PORTAL_SLUG as string | undefined;
  if (forced) return forced;

  return CLIENT_PORTAL_HOSTS[hostname] ?? null;
}
